import { createFileRoute } from '@tanstack/react-router';

import { SalesSettingsPage } from '../../../features/sales/ui/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/sales')({
  // Настройки продаж видит только `sales.manage`; остальным раздел в меню не показывается и по ссылке не открывается.
  beforeLoad: requireSettingsPermission('sales.manage'),
  component: SalesSettingsPage,
});
